import BaseService from '@/services/base_service';
import Axios from 'axios';

export default class IntegratorService extends BaseService {
  async list(params) {
    try {
      return await axios.get('/integradora', params);
    } catch (e) {
      throw e;
    }
  }

  async get(id) {
    try {
      return await axios.get('/integradora/' + id);
    } catch (e) {
      throw e;
    }
  }

  async create(model) {
    try {
      return await axios.post('integradora/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/integradora/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/integradora/' + id);
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/integrator.js